import React from 'react';
import { motion } from 'framer-motion';
interface CTAButtonProps {
  text: string;
  subtext?: string;
  className?: string;
}
export function CTAButton({
  text,
  subtext,
  className = ''
}: CTAButtonProps) {
  const checkoutUrl = 'https://checkout.solucionstore.shop/cart/45164104384703:1';
  return <div className={`w-full max-w-2xl mx-auto ${className}`} data-id="element-32">
      <motion.a href={checkoutUrl} target="_blank" rel="noopener noreferrer" className="block w-full text-center cursor-pointer group" whileHover={{
      scale: 1.02
    }} whileTap={{
      scale: 0.98
    }} animate={{
      scale: [1, 1.03, 1],
      boxShadow: ['0px 0px 0px rgba(34, 197, 94, 0.7)', '0px 0px 20px rgba(34, 197, 94, 0.7)', '0px 0px 0px rgba(34, 197, 94, 0.7)']
    }} transition={{
      duration: 2,
      repeat: Infinity,
      repeatType: 'loop'
    }} data-id="element-33">
        <div className="bg-gradient-to-b from-[#22C55E] to-[#16A34A] hover:from-[#4ADE80] hover:to-[#22C55E] border-b-4 border-[#15803D] rounded-xl py-4 px-6 md:py-6 md:px-8 shadow-xl transform transition-all" data-id="element-34">
          <span className="block text-xl md:text-3xl font-black text-white uppercase tracking-wide drop-shadow-sm" data-id="element-35">
            {text}
          </span>
          {subtext && <span className="block text-sm md:text-base font-bold text-green-100 mt-1" data-id="element-36">
              {subtext}
            </span>}
        </div>
      </motion.a>
      <div className="flex items-center justify-center gap-4 mt-3" data-id="element-37">
        {/* Mercado Pago */}
        <svg viewBox="0 0 48 48" className="h-8 w-auto" aria-label="Mercado Pago" data-id="element-38">
          <rect width="48" height="48" rx="8" fill="#00B1EA" data-id="element-39" />
          <path d="M24 10c-2.5 0-5.2 1.8-7.5 4.5C14 17.5 12 22 12 26c0 6.6 5.4 12 12 12s12-5.4 12-12c0-4-2-8.5-4.5-11.5C29.2 11.8 26.5 10 24 10z" fill="#fff" data-id="element-40" />
          <path d="M24 14c-1.8 0-3.7 1.3-5.3 3.2C16.8 19.8 15.5 23 15.5 26c0 4.7 3.8 8.5 8.5 8.5s8.5-3.8 8.5-8.5c0-3-1.3-6.2-3.2-8.8C27.7 15.3 25.8 14 24 14z" fill="#00B1EA" data-id="element-41" />
        </svg>
        {/* Visa */}
        <svg viewBox="0 0 60 40" className="h-7 w-auto" aria-label="Visa" data-id="element-42">
          <rect width="60" height="40" rx="6" fill="#fff" stroke="#e5e7eb" strokeWidth="1" data-id="element-43" />
          <path d="M25.2 27.2h-3.5l2.2-13.4h3.5l-2.2 13.4zm14.3-13.1c-.7-.3-1.8-.5-3.1-.5-3.4 0-5.8 1.8-5.8 4.4 0 1.9 1.7 3 3.1 3.6 1.4.7 1.8 1.1 1.8 1.7 0 .9-1.1 1.3-2.1 1.3-1.4 0-2.1-.2-3.3-.7l-.5-.2-.5 3.1c.8.4 2.3.7 3.9.7 3.6 0 6-1.8 6-4.5 0-1.5-.9-2.7-2.9-3.6-1.2-.6-1.9-1-1.9-1.6 0-.6.6-1.1 1.9-1.1 1.1 0 1.9.2 2.5.5l.3.1.6-3.2zm8.8-.3h-2.7c-.8 0-1.4.2-1.8 1.1l-5 12.3h3.6l.7-2h4.3l.4 2h3.2l-2.7-13.4zm-4.1 8.6c.3-.8 1.4-3.7 1.4-3.7s.3-.8.5-1.3l.2 1.2s.7 3.3.8 4h-3l.1-.2zM22.6 13.8l-3.4 9.1-.4-1.8c-.6-2.2-2.6-4.5-4.8-5.7l3 11.7h3.6l5.4-13.3h-3.4z" fill="#1A1F71" data-id="element-44" />
          <path d="M16.2 13.8h-5.5l-.1.3c4.3 1.1 7.1 3.7 8.3 6.9l-1.2-6c-.2-.8-.8-1.1-1.5-1.2z" fill="#F9A533" data-id="element-45" />
        </svg>
        {/* Mastercard */}
        <svg viewBox="0 0 60 40" className="h-7 w-auto" aria-label="Mastercard" data-id="element-46">
          <rect width="60" height="40" rx="6" fill="#fff" stroke="#e5e7eb" strokeWidth="1" data-id="element-47" />
          <circle cx="24" cy="20" r="10" fill="#EB001B" data-id="element-48" />
          <circle cx="36" cy="20" r="10" fill="#F79E1B" data-id="element-49" />
          <path d="M30 12.8a10 10 0 0 0-3.7 7.2 10 10 0 0 0 3.7 7.2 10 10 0 0 0 3.7-7.2 10 10 0 0 0-3.7-7.2z" fill="#FF5F00" data-id="element-50" />
        </svg>
      </div>
    </div>;
}